// No frontend dependencies here

export const RELEX_ERROR_EMAIL = 'relex.virhetilanteet@kesko.fi';
export const ORDER_SYNC_IS_ERRORS_EMAIL = 'tilaukset.intersport@kesko.fi';
export const ORDER_SYNC_BS_ERRORS_EMAIL = 'tilaukset@budgetsport.fi';

export const PRODUCT_TYPE_TO_FEDAS_TYPE = {
  equipment: '1',
  clothing: '2',
  shoe: '3',
} as const;

export const FEDAS_TYPE_TO_PRODUCT_TYPE = {
  '1': 'equipment',
  '2': 'clothing',
  '3': 'shoe',
} as const;

export const CURRENCY = {
  EUR: 'EUR',
  USD: 'USD',
} as const;

export type CURRENCY = (typeof CURRENCY)[keyof typeof CURRENCY];

export const TARGET_GROUP_MAPPING = {
  MENS: 'men',
  'ADULT UNISEX': 'unisex',
  WOMEN: 'women',
  MEN: 'men',
  'Kids - KIDS GRADE SCHOOL': 'children',
  'Kids - KIDS PRE SCHOOL': 'children',
};

export const BASE_UNIT_MAPPING = {
  PAR: 'PAA',
  PKT: 'PAC',
  PIECES: 'PC',
  PC: 'PC',
  PCE: 'PC',
  PCS: 'PC',
  ST: 'PC',
  KPL: 'PC',
  PAA: 'PAA',
  PR: 'PAA',
  PAC: 'PAC',
  PAK: 'PAC',
  PTK: 'PAC',
  CAR: 'CAR',
  KI: 'CAR',
  LTK: 'CAR',
};
